import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate, Outlet } from "react-router-dom";
import "./assets/css/app.scss";
import { _adr } from "./address";
import Landing from "./pages/landing/landing";
import { useTheme } from "./context/ThemeContext";
import LangingDetails from "./pages/landing/details/landingDetails";
import Login from "./pages/security/Login/Login";
import Profile from "./pages/accounting/newUser/profile/profile";
import Address from "./pages/accounting/newUser/address/Address";
import BankInfo from "./pages/accounting/newUser/bankInfo/BankInfo";
import Review from "./pages/accounting/newUser/review/Review";
import { CheckToken, setToken } from "./tools/services";
import { useAPIPublic } from "./tools/api";
import { ProtectedRoute, ProtectedRouteLogin } from "./tools/protectedRoute";
import Wallet from "./pages/accounting/wallet/wallet";
import Transactions from "./pages/accounting/Transactions/Transactions";
import { Provider } from "react-redux";
import { persistor, store } from "./reducer/store";
import { PersistGate } from "redux-persist/integration/react";
import Withdraw from "./pages/accounting/Withdraw/Withdraw";
import Order from "./pages/accounting/order/Order";
import Layouts, { useLayouts } from "./pages/layout/layouts";

export const App = () => {
  const { isRTL, fontFamily } = useTheme();
  useEffect(() => {
    document.documentElement.style.setProperty("--dir-page", isRTL ? "rtl" : "ltr");
    document.documentElement.style.setProperty("--dir-text", fontFamily);
  }, [isRTL, fontFamily]);

  return (
    <div id="container">
      <Router>
        <Provider store={store}>
          <PersistGate persistor={persistor}>
            <Routes>
              <Route
                element={
                  <Layouts>
                    <ScrollToTop />
                    <Outlet />
                  </Layouts>
                }
              >
                <Route path={_adr.Root} element={<Landing />} />
                <Route path={_adr.Root + _adr.Landing.Index} element={<Landing />} />
                <Route path={_adr.Root + _adr.Landing.Index + _adr.Landing.Details} element={<LangingDetails />} />

                <Route path={_adr.Root + _adr.Security.Login} element={<ProtectedRouteLogin element={Login} />} />

                <Route
                  path={_adr.Root + _adr.Accounts.Index + _adr.Accounts.NewUser.Index + _adr.Accounts.NewUser.Profile}
                  element={<ProtectedRouteLogin role="global" element={Profile} />}
                />
                <Route
                  path={_adr.Root + _adr.Accounts.Index + _adr.Accounts.NewUser.Index + _adr.Accounts.NewUser.Address}
                  element={<ProtectedRouteLogin role="global" element={Address} />}
                />
                <Route
                  path={_adr.Root + _adr.Accounts.Index + _adr.Accounts.NewUser.Index + _adr.Accounts.NewUser.BankInfo}
                  element={<ProtectedRouteLogin role="global" element={BankInfo} />}
                />
                <Route
                  path={_adr.Root + _adr.Accounts.Index + _adr.Accounts.NewUser.Index + _adr.Accounts.NewUser.Review}
                  element={<ProtectedRouteLogin role="global" element={Review} />}
                />

                <Route path={_adr.Root + _adr.Accounts.Index + _adr.Accounts.Order.Index} element={<ProtectedRoute element={Order} />} />

                <Route path={_adr.Root + _adr.Accounts.Index + _adr.Accounts.Wallet.Index} element={<ProtectedRoute element={Wallet} />} />

                <Route
                  path={_adr.Root + _adr.Accounts.Index + _adr.Accounts.Transactions.Index}
                  element={<ProtectedRoute element={Transactions} />}
                />

                <Route path={_adr.Root + _adr.Accounts.Index + _adr.Accounts.Withdraw.Index} element={<ProtectedRoute element={Withdraw} />} />
              </Route>
            </Routes>
          </PersistGate>
        </Provider>
      </Router>
    </div>
  );
};

const ScrollToTop = ({ callback }) => {
  const { changeLayout } = useLayouts();
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (pathname.includes("login")) {
      changeLayout(false);
    } else {
      changeLayout(true);
    }
  }, [pathname]);
};

export default App;
